import { createSlice } from "@reduxjs/toolkit";
// thunks
import {
  createBrand,
  deleteBrand,
  editBrandById,
  fetchBrandById,
  fetchBrandList,
} from "../thunks/brandThunk.tsx";
import { BrandItemType, BrandListType } from "../types/brandTypes.tsx";
import { getStorageName } from "../../helpers/storageName/storageName.ts";

interface State {
  isLoading: boolean;
  isLoadingById: boolean;
  isLoadingEditById: boolean;
  isLoadingDelete: boolean;
  brandList: BrandListType | null;
  currentBrand: string | null;
  brandById: BrandItemType | null;
}

const initialState: State = {
  isLoading: false,
  isLoadingById: false,
  isLoadingEditById: false,
  isLoadingDelete: false,
  brandList: null,
  currentBrand: null,
  brandById: null,
};
export const brandSlice = createSlice({
  name: "brand",
  initialState,
  reducers: {
    setCurrentBrand: (state, action) => {
      if (action.payload) {
        state.currentBrand = action.payload.toString();
      } else {
        state.currentBrand = null;
      }
    },
    clearBrandById: (state) => {
      state.brandById = initialState.brandById;
    },
    setNewCurrentBrand: (state, action) => {
      if (action.payload) {
        localStorage.setItem(getStorageName.currentBrand, action.payload);
        state.currentBrand = action.payload.toString();
      } else {
        localStorage.removeItem(getStorageName.currentBrand);
        state.currentBrand = null;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchBrandList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(fetchBrandList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.brandList = action.payload;
    });
    builder.addCase(fetchBrandById.pending, (state) => {
      state.isLoadingById = true;
    });
    builder.addCase(fetchBrandById.fulfilled, (state, action) => {
      state.isLoadingById = false;
      state.brandById = action.payload;
    });
    builder.addCase(editBrandById.pending, (state) => {
      state.isLoadingEditById = true;
    });
    builder.addCase(editBrandById.fulfilled, (state, action) => {
      state.isLoadingEditById = false;
      state.brandById = { ...state.brandById, ...action.payload };
    });
    builder.addCase(editBrandById.rejected, (state) => {
      state.isLoadingEditById = false;
    });
    builder.addCase(createBrand.pending, (state) => {
      state.isLoadingEditById = true;
    });
    builder.addCase(createBrand.fulfilled, (state, action) => {
      state.isLoadingEditById = false;
      state.brandById = action.payload;
    });
    builder.addCase(createBrand.rejected, (state) => {
      state.isLoadingEditById = false;
    });
    builder.addCase(deleteBrand.pending, (state) => {
      state.isLoadingDelete = true;
    });
    builder.addCase(deleteBrand.fulfilled, (state, action) => {
      state.isLoadingDelete = false;
      if (action.payload && state.brandList) {
        state.brandList = state.brandList.filter(
          (item) => item.id.toString() !== action.payload,
        );
      }
    });
    builder.addCase(deleteBrand.rejected, (state) => {
      state.isLoadingDelete = false;
    });
  },
});

export const { setCurrentBrand, setNewCurrentBrand, clearBrandById } =
  brandSlice.actions;
